import { put, call, takeLatest, select, all } from 'redux-saga/effects'

import { companyId } from '@/core/selectors/sessions'

import * as hiringAnalyticsView from '../reducks/hiringAnalytics'
import { getPositions } from '@/core/apiModules/hiringAnalytics'
import { errorHandler } from '@/core/helpers/errorHelpers'
import { showSystemError, hideSystemError } from '@/core/components/SystemErrorRedux'

function* fetchPositions() {
  try {
    yield put(hideSystemError())

    const id = yield select(companyId)
    const response = yield call(getPositions, id)
    yield put(hiringAnalyticsView.fetchPositionsSuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(hiringAnalyticsView.fetchPositionsError(error))

    yield put(showSystemError(error))
  }
}

export default function* watchPositionsSaga() {
  yield all([takeLatest(hiringAnalyticsView.FETCH_POSITIONS, fetchPositions)])
}
